import { Box, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DashboardDataTable from 'modules/common/dashboardDataTable.component';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: theme.spacing(2),
  },
  noFiles: {
    padding: theme.spacing(3),
    textAlign: 'center',
  },
}));

const ActiveFilesTable = ({ files, isLoading }) => {
  const classes = useStyles();

  const handleRowClick = (fileId) => {
    window.open(`/authorizations/${fileId}`, '_blank', 'noopener,noreferrer');
  };

  const columns = [
    {
      accessorKey: 'fileNumber',
      header: 'Auth ID',
      Cell: ({ cell }) => cell.getValue() || '-',
    },
    {
      accessorKey: 'eeFullName',
      header: 'Employee',
      Cell: ({ cell }) => cell.getValue() || '-',
    },
    {
      accessorKey: 'clientName',
      header: 'Client',
      Cell: ({ cell }) => cell.getValue() || '-',
    },
    {
      accessorKey: 'fileTypeDescription',
      header: 'File Type',
      Cell: ({ cell }) => cell.getValue() || '-',
    },
    {
      accessorKey: 'initiationDate',
      header: 'Initiation Date',
      Cell: ({ cell }) => (cell.getValue() ? new Date(cell.getValue()).toLocaleDateString() : '-'),
    },
  ];

  if (isLoading) {
    return (
      <Paper elevation={0} className={classes.tableContainer}>
        <Typography className={classes.noFiles} color="textSecondary">
          Loading files...
        </Typography>
      </Paper>
    );
  }

  if (files.length === 0) {
    return (
      <Paper elevation={0} className={classes.tableContainer}>
        <Typography className={classes.noFiles} color="textSecondary">
          No active files found.
        </Typography>
      </Paper>
    );
  }

  return (
    <Box className={classes.tableContainer}>
      <DashboardDataTable
        columns={columns}
        data={files}
        initialSorting={[{ id: 'initiationDate', desc: true }]}
        muiTableBodyRowProps={({ row }) => ({
          onClick: () => handleRowClick(row.original.fileId),
          sx: { cursor: 'pointer' },
          hover: true,
        })}
      />
    </Box>
  );
};

ActiveFilesTable.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      fileId: PropTypes.number.isRequired,
      fileNumber: PropTypes.string,
      eeFullName: PropTypes.string,
      clientName: PropTypes.string,
      fileTypeDescription: PropTypes.string,
      initiationDate: PropTypes.string,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ActiveFilesTable;
